import React, { useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Loader } from '../../core/components';
import GlobalConfig from '../../core/api/GlobalConfig';
import LoginPage from './LoginPage';
import { useAuthenticationContext } from '../../core/services/AuthenticationProvider';
import LanguageService from '../../core/services/LanguageService';
import UserLanguageService from '../../core/services/UserLanguageService';
import { LanguageCode, toBackendCulture } from '../../core/i18n/languages';
import { loginTranslations } from './loginTranslations';

const LoginRoute = () => {
  const useLegacyLogin = GlobalConfig.val().UseLegacyLogin;
  const caseStatusEnabled = GlobalConfig.val().MyPageCaseStatusWithoutLoginEnabled ?? false;
  const authContext = useAuthenticationContext();
  const history = useHistory();
  const location = useLocation();

  const [language, setLanguage] = useState<LanguageCode>(() => {
    const resolved = LanguageService.resolve();
    UserLanguageService.setLanguageCode(toBackendCulture(resolved) ?? resolved);
    return resolved;
  });

  const loginError =
    new URLSearchParams(location.search).get('error') === 'ssn_not_found'
      ? loginTranslations[language].debtorNotFound
      : null;

  // For legacy login, just show loader as the authentication provider handles redirect
  if (useLegacyLogin) {
    return <Loader main={true} />;
  }

  const handleLanguageChange = (code: LanguageCode) => {
    LanguageService.set(code);
    UserLanguageService.setLanguageCode(toBackendCulture(code) ?? code);
    setLanguage(code);
  };

  const handleLoginClick = () => {
    if (authContext.signinRedirect) {
      authContext.signinRedirect();
    }
  };

  const handleCaseSearch = (caseNumber: string) => {
    history.push(`/case-verify?caseNumber=${encodeURIComponent(caseNumber)}`);
  };

  return (
    <LoginPage
      language={language}
      onLanguageChange={handleLanguageChange}
      onLoginClick={handleLoginClick}
      error={loginError}
      caseStatusEnabled={caseStatusEnabled}
      onCaseSearch={handleCaseSearch}
    />
  );
};

export default LoginRoute;
